import type { Theme } from "@mui/material";

export default function getAlertOverrides(theme: Theme) {
  return {
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          "&.MuiPaper-root": {
            borderRadius: 16,
          },
        },
      },
    },
  };
}
